import React, { useState } from "react";
import { IMenuSectionProps } from "./Sections";
import { SectionHeader } from "./SectionHeader";
import { SubSectionLoader } from "./SubSections";
import "@metricell/smarttoolscore/dist/module/Styles/metricell.css";

export const SectionTower: React.FunctionComponent<IMenuSectionProps> = (
    props,
): React.ReactElement => {
    const [isVisible, setIsVisible] = useState<boolean>(true),
        [selectedSubSection, setSelectedSubSection] = useState<number>(null),
        [searchQuery, setSearchQuery] = useState<string>(null);

    const bindSubSection = (subSectionID: number): void => {
        setSelectedSubSection(subSectionID);
    };

    const searchCallback = (newSearchQuery: string): void => {
        setSearchQuery(newSearchQuery === `` ? null : newSearchQuery);
    };

    const loader: SubSectionLoader = new SubSectionLoader(
            props,
            bindSubSection,
        ),
        subSectionList: React.ReactNode[] = [];

    if (searchQuery !== null) {
        if (props.subSections) {
            for (let i = 0; i < props.subSections.length; i++) {
                subSectionList.push(
                    loader.getFilteredSubSection(
                        props.subSections[i],
                        searchQuery,
                    ),
                );
            }
        }
    } else {
        if (
            props.subSections.find((ss) => ss.id === selectedSubSection) == null
        ) {
            let selectedSubSectionTemp: number = null;

            if (props.subSections.length > 0) {
                selectedSubSectionTemp = props.subSections[0].id;
            }

            setIsVisible(!isVisible);
            setSelectedSubSection(selectedSubSectionTemp);
        }

        if (props.subSections) {
            for (let i = 0; i < props.subSections.length; i++) {
                subSectionList.push(
                    loader.getSubSection(
                        props.subSections[i],
                        props.subSections[i].id === selectedSubSection,
                    ),
                );
            }
        }
    }

    return (
        <div className={`navtower-section`}>
            <div className={`scroll`}>
                <SectionHeader
                    searchFunction={searchCallback}
                    sectionProps={props}
                />
                {subSectionList}
            </div>
        </div>
    );
};
